import React, { useEffect, useState } from "react";

import Topbar from "../Topbar/Topbar";
import { Container, Row, Col } from "react-bootstrap";
import "./Dashboard.css";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaThumbsUp } from "react-icons/fa";
import { MdMessage } from "react-icons/md";

import axios from "axios";
import MessageBox from "../MessageBox/MessageBox";

import { useSelector } from "react-redux";

export default function Dashboard() {
  const permissions = useSelector((state) => state.permissions); // Adjust based on your reducer path
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [messageData, setMessageData] = useState([]);
  const [pageRefId, setpageRefId] = useState("");
  //Enquiry
 const [leadCounts, setLeadCounts] = useState({});

  //Dues
   const [duesCounts, setDuesCounts] = useState({});
 

  //Recovery
  const [recoveryCounts, setRecoveryCounts] = useState({});
  //Installation
  let [installationStatusCounts, setInstallationStatusCounts] = useState([]);

  //complaint
  let [complaintStatusCounts, setComplaintStatusCounts] = useState([]);
  //task
 const [taskCounts, setTaskCounts] = useState({});
  //Enquiry

  useEffect(() => {
    axios
      .get(apiUrl+"enquiry-status")
      .then((res) => setLeadCounts(res.data))
      .catch((err) => console.error("Enquiry status error:", err));
  }, [apiUrl]);
  //Dues

  useEffect(() => {
    axios
      .get(apiUrl + "dues-status")
      .then((res) => {
        setDuesCounts(res.data);
      })
      .catch((err) => {
        console.error("Error fetching dues status:", err);
      });
  }, [apiUrl]);
  //Recovery
 useEffect(() => {
    axios
      .get(apiUrl+"recovery-status")
      .then((res) => setRecoveryCounts(res.data))
      .catch((err) => console.error("Collection lead status error:", err));
}, [apiUrl]);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await axios.get(apiUrl + "get-message");

        if (response.status === 200 && Array.isArray(response.data)) {
          setMessageData(response.data); // ✅ Only the array!
        } else {
          console.error("Unexpected response structure:", response);
          setMessageData([]); // fallback to empty array
        }
      } catch (error) {
        console.error("Error fetching messages:", error);
        setMessageData([]); // fallback to empty array
      }
    };

    fetchMessages();
  }, [apiUrl, pageRefId]);

  console.log(messageData);

  //Installation

  useEffect(() => {
    axios.get(apiUrl + "installation-stats", {}).then((res) => {
      const add_installation = res.data.stats || [];
      setInstallationStatusCounts(add_installation);
    });
  }, []);
  //complaint

  useEffect(() => {
    axios.get(apiUrl + "complaint-stats", {}).then((res) => {
      const add_installation = res.data.stats || [];
      setComplaintStatusCounts(add_installation);
    });
  }, []);
  //task
   useEffect(() => {
     axios
       .get(apiUrl+"task-status")
       .then((res) => setTaskCounts(res.data))
       .catch((err) => console.error("Task status error:", err));
   }, [apiUrl]);
  return (
    <div>
      <Topbar />
      <Row>
        <Col md={10} sm={8} lg={8}>
          <Container fluid className="right-column-dashboard">
            <h3>Dashboard</h3>
            {permissions?.Dashboard?.["Show All Statistics"]?.Read && (
              <Row className=" row-width">
                <Col className="dashborder mt-4   mb-5 mx-2 ">
                  <Row className="purple-card">
                    <p
                      className="text-center box-txt "
                      style={{ marginTop: "15px" }}
                    >
                      Enquiry
                    </p>
                  </Row>
                  <Row className="number">
                    <h5 className="text-center pt-1">
                      {leadCounts.total}
                    </h5>
                  </Row>
                </Col>
                <Col className="dashborder mt-4 mb-5 mx-1  ">
                  <Row className="green-card">
                    <p className="text-center box-txt">Installation</p>
                  </Row>
                  <Row className="number">
                    <h5 className="text-center">
                      {installationStatusCounts.totalProgressOpen}
                    </h5>
                  </Row>
                </Col>

                <Col className="dashborder mt-4 mb-5  mx-1">
                  <Row className="pink-card ">
                    <p className="text-center box-txt">Complaints</p>
                  </Row>
                  <Row className="number">
                    <h5 className="text-center pt-1">
                      {complaintStatusCounts.total}
                    </h5>
                  </Row>
                </Col>

                <Col className="dashborder mt-4 mb-5 mx-1">
                  <Row className="blue-card">
                    <p className="text-center  box-txt">Dues</p>
                  </Row>
                  <Row className="number">
                    <h5 className="text-center pt-1">
                      {" "}
                     {duesCounts.total}
                    </h5>
                  </Row>
                </Col>
                <Col className="dashborder mt-4 mb-5 mx-1">
                  <Row className="brown-card">
                    <p className="text-center  px-1 box-txt">Recovery</p>
                  </Row>
                  <Row className="number">
                    <h5 className="text-center pt-1">
                      {" "}
                      {recoveryCounts.total}
                    </h5>
                  </Row>{" "}
                </Col>
                <Col className="dashborder mx-1  mt-4 mb-5">
                  <Row className="red-card">
                    <p className="text-center  box-txt">Task</p>
                  </Row>
                  <Row className="number">
                    <h5 className="text-center pt-1">
                    {taskCounts.total}
                    </h5>
                  </Row>
                </Col>
              </Row>
            )}

            <h3 className="text-statistics">Statistics</h3>

            <Row>
              {permissions?.Dashboard?.["Show Enquiry Chart"]?.Read && (
                <Col md={6} sm={6}>
                  <div className="dashboard-card">
                    <div className="card-header">Enquiry Statistics</div>
                    <div className="card-content">
                      <div className="stat-item">
                        <span>Open :</span>
                        <span>{leadCounts["Open"] ?? 0}</span>
                      </div>

                      <div className="stat-item">
                        <span>Hold :</span>
                        <span> {leadCounts["Hold"] ?? 0}</span>
                      </div>
                      <div className="stat-item">
                        <span>No Response :</span>
                        <span>{leadCounts["No Response"] ?? 0}</span>
                      </div>

                      <div className="stat-item">
                        <span>Not Feasible :</span>
                        <span>{leadCounts["Not Feasible"] ?? 0}</span>
                      </div>
                      <div className="stat-item">
                        <span>Converted :</span>
                        <span>{leadCounts["Converted"] ?? 0}</span>
                      </div>
                      <div className="stat-item">
                        <span>Cancelled :</span>
                        <span> {leadCounts["Cancelled"] ?? 0}</span>
                      </div>
                    </div>
                  </div>
                </Col>
              )}
              {permissions?.Dashboard?.["Show Installation Chart"]?.Read && (
                <Col md={6} sm={6}>
                  <div className="dashboard-card">
                    <div className="card-header-install">
                      Installation Statistics
                    </div>
                    <div className="card-content">
                      <div className="stat-item">
                        <span>Open :</span>
                        <span>{installationStatusCounts.open}</span>
                      </div>
                      <div className="stat-item">
                        <span>Activation Pending :</span>
                        <span className="">
                          {installationStatusCounts.activationPending}
                        </span>
                      </div>
                      <div className="stat-item">
                        <span>verified :</span>
                        <span>{installationStatusCounts.verified}</span>
                      </div>
                      <div className="stat-item">
                        <span>PaymentDue :</span>
                        <span>{installationStatusCounts.paymentDue}</span>
                      </div>
                      <div className="stat-item">
                        <span>FieldTeamWorking:</span>
                        <span>
                          {" "}
                          {installationStatusCounts.fieldTeamWorking}
                        </span>
                      </div>
                      <div className="stat-item">
                        <span>Completed :</span>
                        <span>{installationStatusCounts.completed}</span>
                      </div>
                      <div className="stat-item">
                        <span>Cancelled :</span>
                        <span>{installationStatusCounts.cancelled}</span>
                      </div>

                      
                    </div>
                  </div>
                </Col>
              )}
            </Row>

            <Row className="mt-4">
              {permissions?.Dashboard?.["Show Complaints Chart"]?.Read && (
                <Col md={6} sm={6}>
                  <div className="dashboard-card">
                    <div className="card-header-complaints">
                      Complaints Statistics
                    </div>
                    <div className="card-content">
                      <div className="stat-item">
                        <span>Open :</span>
                        <span> {complaintStatusCounts.open}</span>
                      </div>
                     <div className="stat-item">
                        <span>Re-Opened :</span>
                        <span>0</span>
                      </div>
                       
                      <div className="stat-item">
                        <span>Progress :</span>
                        <span>{complaintStatusCounts.pending}</span>
                      </div>
                      <div className="stat-item">
                        <span>Completed :</span>
                        <span>{complaintStatusCounts.completed}</span>
                      </div>

                        <div className="stat-item">
                      <span>Resolved (With Feedback) :</span>
                      <span>0</span>
                    </div>
                    <div className="stat-item">
                      <span>Resolved This Month :</span>
                      <span>0</span>
                    </div>
                    <div className="stat-item">
                      <span>Re-Opened This Month :</span>
                      <span>0</span>
                    </div>
                    </div>
                  </div>
                </Col>
              )}
              {permissions?.Dashboard?.["Show Due sChart"]?.Read && (
                <Col md={6} sm={6}>
                  <div className="dashboard-card">
                    <div className="card-header-dues">Dues Statistics</div>
                    <div className="card-content">
                      <div className="stat-item">
                        <span>Open :</span>
                        <span>{duesCounts["Open"] ?? 0}</span>
                      </div>
                      <div className="stat-item">
                        <span>Paid :</span>
                        <span className="">{duesCounts["Paid"] ?? 0} </span>
                      </div>
                      <div className="stat-item">
                        <span>Reminder 1 :</span>
                        <span>{duesCounts["Reminder 1"] ?? 0}</span>
                      </div>
                      <div className="stat-item">
                        <span>Reminder 2 :</span>
                        <span>{duesCounts["Reminder 2"] ?? 0}</span>
                      </div>
                      <div className="stat-item">
                        <span>Reminder 3 :</span>
                        <span>  {duesCounts["Reminder 3"] ?? 0}</span>
                      </div>
                      <div className="stat-item">
                        <span>More Than 3 Reminder :</span>
                        <span>{duesCounts["> 3 Reminder"] ?? 0}</span>
                      </div>
                      <div className="stat-item">
                        <span>Suspended 3 :</span>
                        <span>{duesCounts["Suspended"] ?? 0}</span>
                      </div>
                      <div className="stat-item ms-2">
                        <span> Disable :</span>
                        <span>  {duesCounts["Disable"] ?? 0}</span>
                      </div>
                    </div>
                  </div>
                </Col>
              )}
            </Row>

            <Row className="mt-4">
              {permissions?.Dashboard?.["Show Recovery Chart"]?.Read && (
                <Col md={6} sm={6}>
                  <div className="dashboard-card">
                    <div className="card-header-recovery">
                      Recovery Statistics
                    </div>
                    <div className="card-content">
                      <div className="stat-item">
                        <span>Open :</span>
                        <span> {recoveryCounts["Open"] ?? 0}</span>
                      </div>
                      <div className="stat-item">
                        <span>Progress :</span>
                        <span className="number-enquiry">
                          {recoveryCounts["Progress"] ?? 0}
                        </span>
                      </div>
                      <div className="stat-item">
                        <span>Completed :</span>
                        <span>{recoveryCounts["Collected"] ?? 0}</span>
                      </div>
                      <div className="stat-item">
                        <span>Out Of Station:</span>
                        <span>{recoveryCounts["Out Of Station"] ?? 0}</span>
                      </div>
                      <div className="stat-item">
                        <span>Not Handover :</span>
                        <span>{recoveryCounts["Not Handover"] ?? 0}</span>
                      </div>
                      <div className="stat-item">
                        <span>Not Available :</span>
                        <span>{recoveryCounts["Not Available"] ?? 0}</span>
                      </div>
                      <div className="stat-item">
                        <span>Expect Renewal :</span>
                        <span>{recoveryCounts["Expect Renewal"] ?? 0}</span>
                      </div>
                    </div>
                  </div>
                </Col>
              )}
              {permissions?.Dashboard?.["Show Task Chart"]?.Read && (
                <Col md={6} sm={6}>
                  <div className="dashboard-card">
                    <div className="card-header-task">Task Statistics</div>
                    <div className="card-content">
                      <div className="stat-item">
                        <span>Open :</span>
                        <span> {taskCounts["Open"] ?? 0}</span>
                      </div>
                      <div className="stat-item">
                        <span>Progress :</span>
                        <span className="">{taskCounts["Progress"] ?? 0}</span>
                      </div>
                      <div className="stat-item">
                        <span>Completed :</span>
                        <span>{taskCounts["Completed"] ?? 0}</span>
                      </div>
                      <div className="stat-item">
                        <span>Upcomming :</span>
                        <span>{taskCounts["Upcomming"] ?? 0}</span>
                      </div>
                      <div className="stat-item">
                        <span>Overdue :</span>
                        <span>{taskCounts["Over Due"] ?? 0}</span>
                      </div>
                    </div>
                  </div>
                </Col>
              )}
            </Row>
          </Container>
        </Col>

        <Col lg={4} md={6} sm={4} style={{ height: "600px" }}>
          <Container fluid className="dashboard-adds ">
            <>
              <h3 className="text-center update-bg">Updates</h3>
              {/* <div className="update-border-container text-center mb-4">
                <Row className="name-update mt-4">
                  <Col className="mt-3" md={5} sm={5}>
                    <p>K.Saravanan 2h</p>
                  </Col>
                  <Col className="mt-3" md={4} sm={4}>
                    <p>Recently /Collected</p>
                    <div></div>
                  </Col>
                  <Col md={1} sm={1} className="text-end threedots-left mt-3">
                    <span>
                      <BsThreeDotsVertical />
                    </span>
                  </Col>
                </Row>
                <p>Single Band Router Collected Succesfully</p>
                <div className="image-bg-update text-center">
                  <img
                    src="data:image/jpeg;base64,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"
                    width="100%"
                    height="280px"
                    style={{ marginTop: "25px" }}
                  />
                </div>

                <hr />

                <p className="enter-comments">
                  34
                  <span className="thumbsup-update">
                    {" "}
                    <FaThumbsUp className="xx" />
                  </span>{" "}
                  <input placeholder="Enter Comments" type="text" /> 12{" "}
                  <MdMessage />
                </p>
                <Row>
                  <Col md={3} sm={3} xs={3}>
                    <img
                      className="logo-update"
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSEmp3R8ynAPEGVeHz0qCFyFoZkGdA20FkxgA&s"
                      width="50px"
                      height="50px"
                    />
                  </Col>
                  <Col
                    md={8}
                    sm={8}
                    xs={8}
                    className="text-start chat-background"
                  >
                    <h6 className="mt-1">Naveenkumar 5 m</h6>

                    <p>
                      That Customer is very Nice Customer Bro. Previous Dues he
                      paid properly. So, I suggest give some Data to the
                      Customer
                    </p>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md={3} sm={3} xs={3}>
                    <img
                      className="logo-update"
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTVhHYHwsBuokf6mFxAQ5oGylyQfPALYYpz4A&s"
                      width="50px"
                      height="50px"
                    />
                  </Col>
                  <Col
                    md={8}
                    sm={8}
                    xs={8}
                    className="text-start chat-background"
                  >
                    <h6 className="mt-1">Naveenkumar 5 m</h6>

                    <p>
                      That Customer is very Nice Customer Bro. Previous Dues he
                      paid properly. So, I suggest give some Data to the
                      Customer
                    </p>
                  </Col>
                </Row>

                <p className="text-start mx-4 mt-3 mb-4">
                  Assigned By: Ravikumar{" "}
                </p>
              </div> */}

              {/* <Row className="container  ">
                <Col md={12} sm={12}> */}
              <div>
                {Array.isArray(messageData) && messageData.length > 0 ? (
                  messageData.map((msg) => (
                    <MessageBox
                      key={msg._id}
                      message={msg}
                      style={{ backgroundColor: "white" }}
                    />
                  ))
                ) : (
                  <div className="text-muted">No messages available.</div>
                )}
              </div>
              {/* </Col> */}

              {/* <Col md={6} sm={12}>
                  <div className="compact-updates-history">
                    <div className="compact-updates-header">Updates History</div>
                    {Array.isArray(messageData) && messageData.length > 0 ? (
                      messageData.map((data, index) => (
                        <div className="compact-update text-center" key={index}>
                          <div className="compact-update-date text-center">
                            {data.updatesHistory.date ? (
                              new Date(data.updatesHistory.date).toLocaleDateString("en-GB") +
                              " - " +
                              new Date(data.updatesHistory.date)
                                .toLocaleTimeString("en-US", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                })
                            ) : (
                              "No date"
                            )}
                          </div>
              
                          <div className="compact-update-user text-center">
                            {data.updatesHistory?.staff?.name || "Unknown"}
                          </div>
              
                          <div
                            className="compact-update-status text-center"
                            style={{ color: data.colorCode || "#000000" }}
                          >
                            {data.updatesHistory?.status || "No Status"}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-muted text-center">No update history available.</div>
                    )}
                  </div>
                </Col> */}
              {/* </Row> */}
            </>
          </Container>
        </Col>
      </Row>
    </div>
  );
}
